import {
  PRE_CALL_SMS_DEFAULT_MINUTES,
  PRE_CALL_SMS_FALLBACK_AGENT_NAME,
  PRE_CALL_SMS_FALLBACK_CUSTOMER_FIRST_NAME,
  PRE_CALL_SMS_SUPPORTED_COUNTRIES,
} from '~/consts/preCallSms';

function normaliseCountryCallingCode(phonePrefix: string | null | undefined): string {
  return phonePrefix == null ? '' : String(phonePrefix).replace(/[^\d]/g, '');
}

export function buildCustomerSmsPhoneNumber(
  phonePrefix: string | null | undefined,
  phone: string | null | undefined,
): string | null {
  const local = phone == null ? '' : String(phone).replace(/\s+/g, '');
  const prefix = normaliseCountryCallingCode(phonePrefix);

  if (!local || !prefix) {
    return null;
  }

  return `+${prefix}${local}`;
}

export function isPreCallSmsSupportedCountry(phonePrefix: string | null | undefined): boolean {
  const prefix = normaliseCountryCallingCode(phonePrefix);

  if (!prefix) {
    return false;
  }

  return PRE_CALL_SMS_SUPPORTED_COUNTRIES.some(({ callingCode }) => callingCode === prefix);
}

export function describePreCallSmsSupportedCountries(): string {
  const demonyms = PRE_CALL_SMS_SUPPORTED_COUNTRIES.map(({ demonym }) => demonym);

  if (demonyms.length <= 1) {
    return demonyms[0] ?? '';
  }

  return `${demonyms.slice(0, -1).join(', ')} and ${demonyms[demonyms.length - 1]}`;
}

export function resolvePreCallSmsCustomerFirstName(givenName: string | null | undefined): string {
  const trimmed = givenName?.trim();
  return trimmed || PRE_CALL_SMS_FALLBACK_CUSTOMER_FIRST_NAME;
}

export function resolvePreCallSmsAgentName(
  agent: { givenName?: string | null; fullName?: string | null } | null | undefined,
): string {
  const givenName = agent?.givenName?.trim();
  if (givenName) {
    return givenName;
  }

  const fullName = agent?.fullName?.trim();
  if (fullName) {
    return fullName;
  }

  return PRE_CALL_SMS_FALLBACK_AGENT_NAME;
}

export function buildPreCallSmsMessage({
  customerFirstName,
  agentName,
  brandName,
  minutes = PRE_CALL_SMS_DEFAULT_MINUTES,
}: {
  customerFirstName: string;
  agentName: string;
  brandName: string;
  minutes?: number;
}): string {
  return [
    `Hi ${customerFirstName}, ${agentName} from ${brandName} will call you in around ${minutes} minutes about your enquiry.`,
    `Please don't reply to this SMS as it is unmonitored.`,
  ].join('\n');
}
